"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncientDecayAbilityHandler = exports.AncientDecayActorAbilityFactory = exports.AncientDecayAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class AncientDecayAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AncientDecay;
        this.__typeName = "AncientDecay";
    }
}
exports.AncientDecayAbilityArgs = AncientDecayAbilityArgs;
let AncientDecayActorAbilityFactory = class AncientDecayActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AncientDecay", "OneEnemies", 1);
    }
};
AncientDecayActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AncientDecay")
], AncientDecayActorAbilityFactory);
exports.AncientDecayActorAbilityFactory = AncientDecayActorAbilityFactory;
let AncientDecayAbilityHandler = class AncientDecayAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.AncientDecayEffectArgs(),
                    onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_2.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "GreenEnergyCircle")),
                });
            }
        });
    }
};
AncientDecayAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AncientDecay)
], AncientDecayAbilityHandler);
exports.AncientDecayAbilityHandler = AncientDecayAbilityHandler;
